export default "__VITE_PUBLIC_ASSET__6aa165e1__"